import styled from "styled-components";
import { Modal } from "antd";
export const LogoContainerWrapper = styled.div`
	display: flex;
	/* position: ${(props) => (props.relative ? "relative" : "absolute")}; */
	position: relative;
	margin-left: ${(props) => (props.relative ? "1rem" : 0)};
	background: transparent;

	img {
		height: 5rem;
		width: 5rem;
		border-radius: 9999px;
		background-color: #ffffff;
		box-shadow: 0 2px 2px 0 rgb(0 0 0 / 35%);
		padding: 0.5rem;
	}

	.button-to-show-info {
		position: absolute;
		right: 0;
		bottom: 0;
		width: 20px;
		height: 22px;
	}
`;
export const HeaderOfficeInfo = styled.div`
	display: flex;
	align-items: center;
	& h4 {
		margin-left: 12px;
	}
	.office__info-img-container {
		width: 60px;
		height: 60px;
		padding: 5px;
		border-radius: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		box-shadow: 0 2px 2px 0 rgb(0 0 0 / 25%);
	}
	& img {
		width: 60px;
	}
`;

export const OfficeInfoContainer = styled.div`
	width: 250px;
	word-break: break-all;

	.office__info-content {
		display: flex;
	}

	& span {
		margin-left: 12px;
	}
`;
export const OfficeModalWrapper = styled(Modal)`
	top: 0px;
	display: flex;
	justify-content: center;
	.ant-modal-content {
		width: 350px;
		border-radius: 8px;
	}
`;
